"use client";

import EarnRewardIllustration from "@/app/assets/images/dollar-5-reward.png";
import GetICMAppModal from "@/app/components/get-icm-app-modal";
import { Card } from "@/components/ui/card";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import Image from "next/image";
import { useState } from "react";
import DownloadAppPlusIconsWhite from "@/app/global/components/download-app-plus-icons-white";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import useMobile from "@/app/hooks/use-mobile";

export function PriceAlertNew() {
    const { isMobile, hasLoaded } = useMobile();
    const [isIcmAppModal, setIsIcmAppModal] = useState(false);

    return (
        <>
            <Card className="relative top-24 hidden h-full max-h-[437px] flex-col overflow-hidden rounded-3xl border-0 border-[#0E0F171A] bg-[#FEF8F3] p-6 pt-8 shadow-sm xs:sticky xs:flex">
                {/* <span className="mb-5 mt-2 w-fit rounded-full border border-[#F15D2A] px-3 py-1 text-xs font-medium text-[#F15D2A]">
                    Coming Soon
                </span> */}

                <div className="mb-2">
                    <p className="flex items-center text-base font-semibold leading-[160%]">
                        <span className="text-[#F15D2A]">Early access</span>
                        <span className="mx-2.5 mt-0.5 inline-block h-[5px] w-[5px] rounded-full bg-[#0F1016]"></span>
                        <span className="text-[#0F1016]">Reserve your spot</span>
                    </p>
                    <p className="mt-2.5 text-nowrap text-xl font-semibold leading-[130%] tracking-[0px] text-[#494F6E]">
                        Claim your free <span className="text-[#CF5127]">$5 bonus</span>
                    </p>
                    {/* <p className="text-[28px] font-bold leading-[130%] tracking-[-0.5px] text-black">
                        &nbsp;
                    </p> */}
                    <p className="mt-4 mb-2 text-base font-medium leading-[140%] text-[#0F1016]">
                        Join Waitlist
                    </p>
                    <span className="block text-[7px]">*Terms & Conditions Apply</span>
                </div>

                <div className="relative -mx-2.5 mt-s14">
                    <Image
                        src={EarnRewardIllustration}
                        alt="$5 reward on US stocks"
                        width={220}
                        height={180}
                        className="h-auto w-full object-contain"
                        priority
                    />
                </div>

                <div className="mt-5 hidden text-center md:block">
                    <RegularButton
                        noIcon
                        showRightIcon={true}
                        rightIcon={<DownloadAppPlusIconsWhite />}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className={
                            "m-auto max-h-[52px] w-full min-w-full justify-between rounded-2xl border border-gray-200 bg-white text-sm sm:max-w-fit md:mb-0"
                        }
                        label={"Download the app"}
                        onClick={() => {
                            setAnalyticsEvent("", "US_Stocks_Asset_Page_Download_the_App_Fold1");
                            setIsIcmAppModal(true);
                        }}
                    />
                </div>
            </Card>

            {isMobile && hasLoaded && (
                <RegularButton
                    id="btn-download-app"
                    noIcon
                    showRightIcon={false}
                    size={ButtonSize.Medium}
                    variant={ButtonVariant.SecondaryDefault}
                    className="fixed bottom-3 left-6 block h-12 min-w-[calc(100%-48px)] border-[#F15D2A] bg-[#F15D2A] text-white hover:bg-[#ec541f] xs:hidden"
                    label="Download the app"
                    onClick={() => {
                        setIsIcmAppModal(true);
                    }}
                />
            )}

            <GetICMAppModal
                open={isIcmAppModal}
                onClose={() => {
                    setIsIcmAppModal(false);
                }}
            />
        </>
    );
}
